let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l2KYG")).then(() => parcelRequire('bfKdu'));